export default {
  APP_HOST: process.env.REACT_APP_APP_HOST || 'http://localhost:4000',
  API_HOST: process.env.REACT_APP_API_HOST || 'http://localhost:4000/api/'
};
